import { useSetAtom } from "jotai";
import { useEffect } from "react";

import { clearAllPhotosAtom } from "atoms/clearAllPhotosAtom";
import { latestReachedCheckpointFlowPageAtom } from "atoms/latestReachedCheckpointFlowPageAtom";
import { useCheckpoint } from "hooks/useCheckpoint";
import { Checkpoint } from "types/Checkpoint";

import { UseTriggerCheckpointProps } from "../types";

export const useTriggerCheckpoint = ({ checkpoint, path }: UseTriggerCheckpointProps) => {
  const setLastCheckpoint = useSetAtom(latestReachedCheckpointFlowPageAtom);
  const setClearAllPhotosAtom = useSetAtom(clearAllPhotosAtom);

  const targetReached = useCheckpoint(checkpoint);

  useEffect(() => {
    if (checkpoint && !targetReached) {
      setLastCheckpoint({ checkpoint, path });

      if (checkpoint === Checkpoint.FLOW_COMPLETED) setClearAllPhotosAtom();
    }
  }, [checkpoint, path, setClearAllPhotosAtom, setLastCheckpoint, targetReached]);
};
